module.exports = __webpack_public_path__ + "img/Aggregation_Geflüchtete.dfb2835b.png";